import Model from '@/lib/data/Model';

class CustomerBroker extends Model {
    static idProperty = 'id';

    fields = ['id', 'name'];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }
}

export default CustomerBroker;
